import React from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

// SortHeader component - reusable sortable table header
export const SortHeader = ({ field, sortField, sortDir, onSort, children }) => (
  <th
    className="py-3 px-3 text-left text-xs font-bold uppercase text-zinc-400 cursor-pointer hover:text-crew-yellow select-none"
    onClick={() => onSort(field)}
  >
    <div className="flex items-center gap-1">
      {children}
      {sortField === field && (
        sortDir === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />
      )}
    </div>
  </th>
);
